var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass:
          "w-100pct h-60px bg-cl-black cl-white f-s-18px f-w-bold pd-18px"
      },
      [
        _c(
          "router-link",
          { attrs: { to: { name: "Home" } } },
          [
            _c("svg-filler", {
              staticClass: "mg-r-auto f-left cs-pointer",
              attrs: {
                path: "/static/svg/back.svg",
                fill: "#ffffff",
                width: "20px",
                height: "20px"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            "\n      มีสินค้าในตระกร้าจำนวน " +
              _vm._s(_vm.amount) +
              " ชิ้น\n    "
          )
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "columns is-marginless is-centered" }, [
      _c(
        "div",
        { staticClass: "list-item column is-6 is-marginless pd-20px" },
        [
          _c(
            "div",
            { staticClass: "columns is-marginless is-paddingless" },
            [
              _c("list-cart", {
                attrs: { items: _vm.items },
                on: { removeItem: _vm.remove }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "columns is-marginless is-paddingless f-left w-100pct"
            },
            [
              _c("div", { staticClass: "column is-6 is-offset-3" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "mg-auto clear-item mg-hrzt-auto cl-white f-w-bold pd-6px cs-pointer",
                    on: {
                      click: function($event) {
                        _vm.clear()
                      }
                    }
                  },
                  [_vm._v("ล้างรายการ")]
                )
              ])
            ]
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "cart-data columns is-marginless is-centered" }, [
      _c("div", { staticClass: "column is-6 is-marginless pd-20px" }, [
        _c("div", { staticClass: "f-s-16px f-w-bold t-al-left" }, [
          _vm._v("\n        เบอร์โทรศัพท์\n      ")
        ]),
        _vm._v(" "),
        !_vm.isTel
          ? _c(
              "div",
              [
                _c("VueTelInput", {
                  staticClass: "input-data f-left pd-6px w-100pct",
                  attrs: { preferredCountries: ["us", "gb", "ua", "th"] },
                  on: { onInput: _vm.onInputTel },
                  model: {
                    value: _vm.tel,
                    callback: function($$v) {
                      _vm.tel = $$v
                    },
                    expression: "tel"
                  }
                })
              ],
              1
            )
          : _c(
              "div",
              [
                _c("VueTelInput", {
                  staticClass: "input-data f-left pd-6px",
                  attrs: { disabled: true },
                  model: {
                    value: _vm.tel,
                    callback: function($$v) {
                      _vm.tel = $$v
                    },
                    expression: "tel"
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "f-left search pd-6px cs-pointer cl-light f-w-bold",
                    on: {
                      click: function($event) {
                        _vm.changTel()
                      }
                    }
                  },
                  [_vm._v("\n          Clear\n        ")]
                )
              ],
              1
            ),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("div", { staticClass: "f-s-16px f-w-bold t-al-left" }, [
          _vm._v("\n        รหัสส่วนลดพิเศษ \n      ")
        ]),
        _vm._v(" "),
        !_vm.isCode
          ? _c("div", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.promoCode,
                    expression: "promoCode"
                  }
                ],
                staticClass: "input-data f-left pd-6px",
                attrs: { placeholder: "GW-1234" },
                domProps: { value: _vm.promoCode },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.promoCode = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "f-left search pd-6px cs-pointer",
                  on: {
                    click: function($event) {
                      _vm.verifyCode()
                    }
                  }
                },
                [
                  _c("svg-filler", {
                    attrs: {
                      path: "/static/svg/search.svg",
                      fill: "#ffffff",
                      width: "20px",
                      height: "20px"
                    }
                  })
                ],
                1
              )
            ])
          : _c("div", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.promoCode,
                    expression: "promoCode"
                  }
                ],
                staticClass: "input-data f-left pd-6px",
                attrs: { placeholder: "GW-1234", disabled: "disabled" },
                domProps: { value: _vm.promoCode },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.promoCode = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "f-left search pd-6px cs-pointer cl-light f-w-bold",
                  on: {
                    click: function($event) {
                      _vm.changCode()
                    }
                  }
                },
                [_vm._v("\n          Clear\n        ")]
              )
            ]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "dp-flex jtf-ct-space-between f-s-16px f-w-bold" },
          [
            _c("div", { staticClass: "w-50pct t-al-left" }, [
              _vm._v("\n          ราคารวม\n        ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "w-50pct t-al-right" }, [
              _vm._v(
                "\n          ฿ " +
                  _vm._s(_vm._f("showFullPriceFormat")(_vm.getFullPrice)) +
                  "\n        "
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "dp-flex jtf-ct-space-between f-s-16px f-w-bold" },
          [
            _c("div", { staticClass: "w-50pct t-al-left" }, [
              _vm._v("\n          ส่วนลดรวม\n        ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "w-50pct t-al-right" }, [
              _vm._v("\n          ฿ "),
              _vm.getFullPrice - _vm.undiscountPrice > 0
                ? _c("span", [_vm._v("-")])
                : _vm._e(),
              _vm._v(
                _vm._s(
                  _vm._f("showFullPriceFormat")(
                    _vm.getFullPrice - _vm.undiscountPrice
                  )
                ) + "\n        "
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "dp-flex jtf-ct-space-between f-s-16px f-w-bold" },
          [
            _c("div", { staticClass: "w-80pct t-al-left" }, [
              _vm._v("\n          ส่วนลดพิเศษ\n          "),
              _vm.promotionCodeDetails.discountType === "amount"
                ? _c("span", { staticClass: "f-s-13px" }, [
                    _vm._v(
                      "ลด ฿ " +
                        _vm._s(
                          _vm._f("showFullPriceFormat")(
                            _vm.promotionCodeDetails.discountNumber
                          )
                        )
                    )
                  ])
                : _vm.promotionCodeDetails.discountType === "percent"
                  ? _c("span", { staticClass: "f-s-13px" }, [
                      _vm._v(
                        "ลด " +
                          _vm._s(
                            _vm._f("showFullPriceFormat")(
                              _vm.promotionCodeDetails.discountNumber
                            )
                          ) +
                          " % "
                      )
                    ])
                  : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "w-50pct t-al-right" }, [
              _vm._v("\n          ฿ "),
              _vm.discount > 0 ? _c("span", [_vm._v("-")]) : _vm._e(),
              _vm._v(
                _vm._s(_vm._f("showFullPriceFormat")(_vm.discount)) +
                  "\n        "
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "dp-flex jtf-ct-space-between f-s-16px f-w-bold" },
          [
            _c("div", { staticClass: "w-50pct t-al-left" }, [
              _vm._v("\n          ราคาสุทธิ\n        ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "w-50pct t-al-right" }, [
              _vm._v(
                "\n          ฿ " +
                  _vm._s(_vm._f("showFullPriceFormat")(_vm.netPrice)) +
                  "\n        "
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "dp-flex jtf-ct-space-between f-w-bold" }, [
          _c(
            "div",
            {
              staticClass: "add-item-btn cs-pointer",
              on: {
                click: function($event) {
                  _vm.$router.push({ name: "ScanToSearch" })
                }
              }
            },
            [_vm._v("\n          + เพิ่มสินค้า\n        ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "checkout-btn cs-pointer",
              on: {
                click: function($event) {
                  _vm.confirm()
                }
              }
            },
            [
              _vm._v(
                "\n          ชำระเงิน (" +
                  _vm._s(_vm._f("showFullPriceFormat")(_vm.netPrice)) +
                  " ฿)\n        "
              )
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7fb050a5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fb050a5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/cart/Cart.vue
// module id = 483
// module chunks = 1